'use client'

import { TFAQCategory } from '@/entities/support'
import { Chip } from '@/shared/ui'

import { useFAQCategory } from '../../lib/category'

type Props = {
  categories: TFAQCategory[]
}

export const FAQCategory = ({ categories }: Props) => {
  const { category, categoriesWithAll, handleCategoryChange } =
    useFAQCategory(categories)

  return (
    <div className="my-10 flex flex-wrap gap-1.5">
      {categoriesWithAll.map(({ categoryCode, categoryName }) => (
        <div key={categoryCode}>
          <Chip
            size="large"
            variant="solid"
            selected={category === categoryCode}
            onClick={() => {
              handleCategoryChange(categoryCode)
            }}
          >
            {categoryName}
          </Chip>
        </div>
      ))}
    </div>
  )
}
